import { Capacitor } from '@capacitor/core'
import { LiveUpdate } from '@capawesome/capacitor-live-update'
import consola from 'consola'

const SYNC_TIMEOUT_MS = 8000

/** Нельзя ждать вечно: при недоступном/медленном хосте Capawesome LiveUpdate.sync() может висеть десятки секунд */
function withTimeout<T>(promise: Promise<T>, ms: number): Promise<T> {
  return Promise.race([
    promise,
    new Promise<T>((_, reject) => setTimeout(() => reject(new Error('LiveUpdate sync timeout')), ms)),
  ])
}

/**
 * Плагин для автоматической проверки принудительных обновлений при запуске.
 * Работает только в нативных приложениях.
 *
 * Nuxt ждёт резолва async-плагинов ПЕРЕД монтированием приложения — если await'ить
 * здесь сетевой запрос, экран каталога чернеет на весь его RTT (а при недоступном
 * хосте — на десятки секунд по TLS-таймауту). Поэтому плагин синхронный, а проверка
 * обновлений уходит в фон и не блокирует старт.
 */
export default defineNuxtPlugin(() => {
  if (!process.client || !Capacitor.isNativePlatform()) return

  consola.log('🔄 Capawesome: Проверка принудительных обновлений при запуске...')

  withTimeout(LiveUpdate.sync(), SYNC_TIMEOUT_MS)
    .then(async (result) => {
      if (result.nextBundleId) {
        consola.log('🔄 Capawesome: Есть обнова')
        await LiveUpdate.reload()
      }
    })
    .catch((error) => {
      consola.error('❌ Capawesome: Ошибка при проверке обновлений:', error)
    })
})
